// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".subheader-content[data-v-387a5f55] {\n  position: relative;\n  z-index: 100;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
